module.exports = "\r\n<router-outlet></router-outlet>\r\n\r\n<p-toast position=\"top-right\"></p-toast>\r\n\r\n\r\n"